import { MATRIX_BACKEND } from '@/remotes';
import { ref, watch } from 'vue';

export function useGetAvailableCities(typeCities) {
  const cities = ref([]);
  watch(async () => {
    const params = new URLSearchParams();
    if (typeCities === 'acceptanceCargo') {
      params.append('acceptanceCargo', true);
    } else {
      params.append('issuanceOfCargo', true);
    }
    try {
      cities.value = (await MATRIX_BACKEND.get('/api/public/cities', { params })).data;
    } catch {
      cities.value = [];
    }
  });

  return cities;
}
